import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function AllPurchasedModal({ isOpen, onClose, poNumber }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1100 }}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "420px", textAlign: "center", padding: "2rem" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
          <div style={{
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            backgroundColor: "rgba(46, 204, 113, 0.15)",
            color: "var(--success)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <CheckCircle2 size={32} />
          </div>
        </div>

        <h3 style={{ fontSize: "1.25rem", color: "var(--text-primary)", margin: "0 0 0.5rem 0" }}>
          Purchase Order Update
        </h3>

        <p style={{ color: "var(--text-secondary)", fontSize: "0.95rem", margin: "0 0 1.75rem 0", lineHeight: "1.5" }}>
          All items have been purchased{poNumber ? ` for ${poNumber}` : ""}.
        </p>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onClose}
            style={{ minWidth: "120px", backgroundColor: "var(--success)", borderColor: "var(--success)", color: "#000000", fontWeight: 600 }}
            autoFocus
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
